import PointerInteraction from 'ol/interaction/Pointer';
import MapBrowserEventType from 'ol/MapBrowserEventType';
import Point from 'ol/geom/Point';

export class AsyncPointSelectionInteraction extends PointerInteraction {

  constructor () {
    super({ handleEvent: event => this._handleEvent(event) });
  }

  _handleEvent (mapBrowserEvent) {
    if (mapBrowserEvent.type === MapBrowserEventType.CLICK) {
      this.asyncSelect(mapBrowserEvent, new Point(mapBrowserEvent.coordinate));
      return false;
    }
    return super.handleEvent(mapBrowserEvent);
  }

  /**
   * Can be overridden in child classes.
   *
   * @protected
   * @param mapBrowserEvent - the open layers event
   * @param geometry - the geometry created by the point where we clicked
   */
  asyncSelect (mapBrowserEvent, geometry) {

  }

}
